import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const Loading = styled(Box)(({ theme }) => ({
  backgroundColor: `${theme.palette.neutrals.beige1}d9`,
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 1,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  flexWrap: 'wrap'
}));
